import React from "react";
import styles from "./Header.module.css";
import hidocConsult from "../assets/images/white.png";
import hidocLogo from "../assets/images/logo_light.png";

const Header = () => {
  return (
    <>
      <div className={styles.nav_list}>
        <img
          src={hidocConsult}
          alt="hidocLogo"
          className={styles.hidoc_consult}
        />
        <div className={styles.Logo_div}>
          <p className={styles.powered_by_title}>Powered by </p>
          <img src={hidocLogo} alt="hidocLogo" className={styles.hidoc_logo} />
        </div>
      </div>
    </>
  );
};

export default Header;
